import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=4f57196e&"
import script from "./photo.vue?vue&type=script&lang=ts&"
export * from "./photo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports